import { clsx } from 'clsx';

export interface TreeLoaderProps {
  className?: string;
}

export function TreeLoader({ className }: TreeLoaderProps) {
  return (
    <div className={clsx('flex items-end justify-center gap-4', className)}>
      <style>{`
        @keyframes tree-bounce {
          0%, 100% {
            transform: scaleY(1) translateY(0);
          }
          50% {
            transform: scaleY(1.15) translateY(-4px);
          }
        }
        .tree-animate {
          animation: tree-bounce 0.8s ease-in-out infinite;
          transform-origin: bottom center;
        }
      `}</style>

      {/* Left tree - smaller */}
      <svg
        className="w-10 h-12 tree-animate"
        style={{ animationDelay: '0ms' }}
        viewBox="0 0 32 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="13" y="32" width="6" height="8" className="fill-green-700" rx="1" />
        <path
          d="M16 4L7 15h5L6 25h20L20 15h5L16 4z"
          className="stroke-green-600 fill-green-500"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {/* Center tree - taller */}
      <svg
        className="w-12 h-16 tree-animate"
        style={{ animationDelay: '150ms' }}
        viewBox="0 0 40 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="16" y="42" width="8" height="10" className="fill-green-700" rx="1" />
        <path
          d="M20 4L9 18h6L7 32h26L25 18h6L20 4z"
          className="stroke-green-600 fill-green-500"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {/* Right tree - smaller */}
      <svg
        className="w-10 h-12 tree-animate"
        style={{ animationDelay: '300ms' }}
        viewBox="0 0 32 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="13" y="32" width="6" height="8" className="fill-green-700" rx="1" />
        <path
          d="M16 4L7 15h5L6 25h20L20 15h5L16 4z"
          className="stroke-green-600 fill-green-500"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

export function FullPageLoader() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-50">
      <TreeLoader />
    </div>
  );
}
